// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { COMMON_MODULE, COMMON_URL } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { CommonNotFound, CommonUnauthorized } = lazily(() => import('pages/common'))

const commonRoutes: IRoute[] = [
  {
    path: COMMON_URL.UNAUTHORIZED,
    component: CommonUnauthorized,
    layout: LAYOUT.EMPTY,
    exact: true,
    meta: {
      module: COMMON_MODULE,
      requireAuth: false,
    },
  },
  {
    path: COMMON_URL.ALL,
    component: CommonNotFound,
    layout: LAYOUT.EMPTY,
    exact: false,
    meta: {
      module: COMMON_MODULE,
      requireAuth: false,
    },
  },
]

export { commonRoutes }
